import {AfterViewInit, Component, Input} from '@angular/core';
import {SchoolClassData} from "../../interfaces/school-class-data";
import {ChartComponentData} from "../../interfaces/chart-component-data";
import {RankingService} from "../../services/ranking.service";
import {OrganizationExperienceService} from "../../services/organization-experience.service";
import {setActiveClassId} from "../../store/actions/teacher.actions";
import {CdColor} from "../../enums/cd-color";
import {ItemActionElement} from "../../atoms/item-actions/item-action-element";
import {Store} from "@ngrx/store";
import {StudentAuthService} from "../../services/student-auth.service";
import {Router} from "@angular/router";
import {NotificationService} from "../../atoms/notification/notification.service";
import {AlertService} from "../../services/alert.service";
import {TeacherGameSetupService} from "../../services/teacher-game-setup.service";
import {untilDestroyed} from "@ngneat/until-destroy";
import {MutationService} from "../../services/mutation.service";
import {SchoolClassDataWithStatsMin} from "../../interfaces/school-class-data-with-stats-min";

@Component({
  selector: 'brt-school-class-mini-preview',
  templateUrl: './school-class-mini-preview.component.html',
  styleUrls: ['./school-class-mini-preview.component.scss']
})
export class SchoolClassMiniPreviewComponent implements AfterViewInit {

  @Input('data') set setSchoolClassData(val: SchoolClassDataWithStatsMin) {
    this.schoolClassData = val;
    // console.log(val);

    this.currentRank = val.schoolClassRankMin?.rank ?? 0;
    this.currentPoints = val.schoolClassRankMin?.points ?? 0;
    this.activityLevel = (val.schoolClassRankMin?.activityLevel ?? 0) + 1;

    this.experienceService.loadSchoolClassHistoryExperience(this.schoolClassData.classCode).then((val) => {
      this.chartData.data.datasets[0].items = [];
      this.chartData.data.datasets[0].items.push(...val.map((el) => { return {label: "", value: el.points}}));

      if(this.chartData.data.datasets[0].items.length < 2) {
        this.chartData.data.datasets[0].items.push(this.chartData.data.datasets[0].items[this.chartData.data.datasets[0].items.length - 1]);
        this.chartData.data.datasets[0].items.push(this.chartData.data.datasets[0].items[this.chartData.data.datasets[0].items.length - 1]);
        this.chartData.data.datasets[0].items.push(this.chartData.data.datasets[0].items[this.chartData.data.datasets[0].items.length - 1]);
      }

      this.chartData = JSON.parse(JSON.stringify(this.chartData));
      // console.log('chart-data', this.chartData);

      this.classPath += this.schoolClassData.id;
    })
  }

  currentRank = 0;
  currentPoints = 0;
  activityLevel = 3;

  menuItems: ItemActionElement[] = [];

  classPath = "/lehrer/klasse/";

  constructor(
    private rankingService: RankingService,
    private store: Store,
    private experienceService: OrganizationExperienceService,
    private alertService: AlertService,
    private studentAuthService: StudentAuthService,
    private router: Router,
    private notificationService: NotificationService,
    private teacherGameSetup: TeacherGameSetupService,
    private mutationService: MutationService
  ) {
  }

  schoolClassData!: SchoolClassData;

  chartData: ChartComponentData = {
    type: 'line-preview',
    data: {
      datasets: [
        {
          items: [],
          label: "",
          color: "#3C5FDB",
        }
      ]
    }
  }

  ngAfterViewInit() {
    this.menuItems = [
      {icon: "play-circle", title: "Game Session starten", isActive: true, func: () => {
          this.store.dispatch(setActiveClassId({classId: this.schoolClassData.id}));
          this.teacherGameSetup.openWizard();
        }},
      {icon: "settings", title: "Klasseninformation ändern", isActive: true, func: () => {
          this.store.dispatch(setActiveClassId({classId: this.schoolClassData.id}));
          this.router.navigateByUrl("/lehrer/klasse-bearbeiten");
        }},
      {icon: "code-enter-klasse", title: "Klassencode anzeigen", isActive: true, func: () => {
          this.alertService.showAlert("<em>" + this.schoolClassData.classCode + "</em>", "Klassen Code", "Schließen");
        }},
      // {icon: "calendar", title: "Buchungen anzeigen", isActive: true, func: () => {alert("Buchungen anzeigen " + this.schoolClassData.id)}},
      // {icon: "add-booking", title: "Neue Buchung erstellen", isActive: true, func: () => {alert("Neue Buchung erstellen " + this.schoolClassData.id)}},
      {icon: "code-note", title: "Unterrichtsidee einreichen", isActive: true, func: () => {
          this.store.dispatch(setActiveClassId({classId: this.schoolClassData.id}));
          this.router.navigate(["/lehrer/unterrichtsidee-einreichen"]);
        }},
      {icon: "link", title: "Klassenprofil öffnen", isActive: true, func: () => {
          if(this.schoolClassData?.classCode) {
            this.studentAuthService.logIn(this.schoolClassData.classCode).then((response) => {
              if(response) {
                this.router.navigateByUrl('/klasse');
              } else {
                this.notificationService.push("Login fehlgeschlagen", CdColor.RED, "x-thin");
              }
            });
          } else {
            this.notificationService.push("Es ist ein Problem aufgetreten", CdColor.RED, "x-thin");
          }
        }},
      {icon: "archive", title: "Klasse archivieren", isActive: true, func: () => {

          if(!confirm("Sind Sie sicher, dass Sie diese Klasse archivieren möchten?")) {
            return;
          }

          // the class list is refetched in the mutation service
          this.mutationService.deleteClass(this.schoolClassData.id).pipe(untilDestroyed(this)).subscribe((data) => {
            if(data && data.type === "OK") {
              this.notificationService.push("Klasse archiviert", CdColor.RIVER, "check-circle");
            } else {
              this.notificationService.push("Klasse konnte nicht archiviert werden", CdColor.RED, "x-thin");
            }
          });
      }},
    ]
  }
}
